var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.galleryItems.length > 0)?_c('lingallery',{attrs:{"items":_vm.galleryItems,"height":300,"iid":_vm.currentId,"disableImageClick":true,"addons":{ enableLargeView: true }},on:{"update:iid":function($event){_vm.currentId=$event}}}):_c('img',{attrs:{"src":_vm.imageSrcProp,"alt":_vm.imageAltProp}})
}
var staticRenderFns = []

export { render, staticRenderFns }